import { render, staticRenderFns } from "./DefectiveSubmit.vue?vue&type=template&id=91c80a4e&scoped=true&"
import script from "./DefectiveSubmit.vue?vue&type=script&lang=js&"
export * from "./DefectiveSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91c80a4e",
  null
  
)

export default component.exports